var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2018_3575",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2018_3575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23187 27.5V18.8053L4.95312 11.875L9.96531 3.75H20.0372L25.0494 11.875L20.7706 18.8053V27.5L15.0012 25.5047L9.23187 27.5ZM10.4819 25.6659L15.0012 24.1537L19.5206 25.6659V20H10.4819V25.6659ZM10.6503 5L6.40031 11.875L10.6503 18.75H19.3522L23.6022 11.875L19.3522 5H10.6503ZM13.6887 16.0794L10.1406 12.5625L11.0325 11.6706L13.6887 14.3269L18.97 9.01438L19.8619 9.875L13.6887 16.0794Z",
    fill: "#B56654"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardBronze);
export default __webpack_public_path__ + "static/media/leaderboard-bronze.94462e3e01e8bf50f71d682c85efacba.svg";
export { ForwardRef as ReactComponent };